export const EMAILAGE_SUCCESS = 'EMAILAGE_SUCCESS'
export const EMAILAGE_FAIL = 'EMAILAGE_FAIL'
export const SMS_SUCCESS = 'SMS_SUCCESS'
export const SMS_FAIL = 'SMS_FAIL'
export const PHONE_SUCCESS = 'PHONE_SUCCESS'
export const PHONE_FAIL = 'PHONE_FAIL'
export const UPDATE_INFO_SUCESS = 'UPDATE_INFO_SUCESS'
export const UPDATE_INFO_FAIL = 'UPDATE_INFO_FAIL'
export const GET_DEVICE_INFO = 'GET_DEVICE_INFO'